import React, { useCallback } from "react"
import Modal from "@/components/common/Modal"
import FormSubmissionModal from "@/components/ModalVariants/FormSubmissionModal"
import { isFunction } from "@/utils/utils"

export default function SubmissionModal({ modalOpen, setModalOpen, modalData, loading, closeModalCallback }) {
	const { closeButtonText, header, icon } = modalData

	const handleModalClose = useCallback(() => {
		setModalOpen(false)
		if (isFunction(closeModalCallback)) {
			closeModalCallback()
		}
	}, [])

	return (
		<Modal isOpen={modalOpen} handleClose={handleModalClose} buttonText={closeButtonText}>
			{!loading && (
				<FormSubmissionModal handleClose={handleModalClose} header={header} icon={icon} closeButtonText={closeButtonText} />
			)}
		</Modal>
	)
}
